<template>
  <div class="appContainer top_container">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('top-page.header', { split: '/' }) }}</h1>
    </div>

    <v-data-table
      :headers="headers"
      :items="
        dataTable !== null &&
        typeof dataTable !== 'undefined' &&
        dataTable.length !== 0
          ? dataTable
          : []
      "
      :items-per-page="ITEM_PER_PAGE"
      class="elevation-1 app_table"
      :no-data-text="noDataText"
      :hide-default-footer="dataTable.length === 0 ? true : false"
    >
      <template v-slot:[`item.read_flag`]="{ item }">
        <span v-if="item.read_flag === READ_FLAG_UN_READ" class="red_text" dark
          >NEW</span
        >
      </template>

      <template v-slot:[`item.subject`]="{ item }">
        <span
          v-if="item.subject"
          @click="handleShowDetail(item)"
          class="link-detail"
          >{{ item.subject }}</span
        >
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">
          {{ convertDateTime(item.created_at) }}
        </span>
      </template>

      <template v-slot:[`item.display_time_to`]="{ item }">
        <span v-if="item.display_time_to">
          {{ convertDateTime(item.display_time_to) }}
        </span>
      </template>
    </v-data-table>

    <hr class="hr-line-homepage hr-line-first" />

    <div class="row pl-3">
      <h4
        class="left-border"
        v-html="
          $t('top-page.info.title', { split: '/' }) + ': ' + m_event.event_name
        "
      ></h4>
    </div>

    <table class="table-homepage">
      <tbody>
        <tr>
          <td>
            {{
              $t('top-page.text-field.event-period', {
                split: '/'
              })
            }}
          </td>
          <td>{{ this.displayEventPeriod() + timezoneFormat() }}</td>
        </tr>
        <tr>
          <td>
            {{
              $t('top-page.text-field.event-address', {
                split: '/'
              })
            }}
          </td>
          <td>{{ m_event.location_address }}</td>
        </tr>

        <tr>
          <td>{{ $t('top-page.text-field.map') }}</td>
          <td>
            <a :href="m_event.location_map_url" target="_blank">{{
              m_event.location_map_url
            }}</a>
          </td>
        </tr>
        <tr>
          <td>
            {{
              $t('top-page.text-field.event-content', {
                split: '/'
              })
            }}
          </td>
          <td>
            <div
              v-html="m_event.event_content"
              class="div-textarea html-content"
            ></div>
          </td>
        </tr>
        <tr
          v-if="
            m_event !== null &&
            m_event.applicant_document !== null &&
            m_event.applicant_document !== ''
          "
        >
          <td>
            {{
              $t('top-page.text-field.company-document', {
                split: '/'
              })
            }}
          </td>
          <td>
            <a :href="m_event.applicant_document" target="_blank">{{
              $t('top-page.document-download', { split: '/' })
            }}</a>
          </td>
        </tr>
      </tbody>
    </table>

    <hr class="hr-line-homepage" v-if="checkDisplayHr()" />

    <table class="table-homepage2">
      <tbody>
        <tr
          v-if="
            m_event !== null && m_event.organizer_name_display == DISPLAY_TAG
          "
        >
          <td>
            {{
              $t('top-page.text-field.organize-name', {
                split: '/'
              })
            }}
          </td>
          <td>{{ m_event.organizer_name }}</td>
        </tr>
        <tr
          v-if="m_event !== null && m_event.cooperator_display == DISPLAY_TAG"
        >
          <td>
            {{
              $t('top-page.text-field.cooperator', {
                split: '/'
              })
            }}
          </td>
          <td>{{ m_event.cooperator }}</td>
        </tr>

        <tr v-if="m_event !== null && m_event.sponsor_display == DISPLAY_TAG">
          <td>
            {{
              $t('top-page.text-field.sponsor', {
                split: '/'
              })
            }}
          </td>
          <td>{{ m_event.sponsor }}</td>
        </tr>
        <tr v-if="m_event !== null && m_event.operator_display == DISPLAY_TAG">
          <td>
            {{
              $t('top-page.text-field.operator', {
                split: '/'
              })
            }}
          </td>
          <td>
            {{ m_event.operator }}
          </td>
        </tr>
      </tbody>
    </table>

    <v-dialog v-model="dialog" width="60vw">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog">{{
          closeIcon
        }}</v-icon>
        <div class="dialog">
          <table class="table-detail-info">
            <tr>
              <td class="td-left">
                {{
                  $t('top-page.title', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                {{ itemDetail !== null && itemDetail.subject }}
              </td>
            </tr>
            <tr>
              <td class="td-left">
                {{
                  $t('top-page.content', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                <div class="textarea-field">
                  <div
                    :class="
                      itemDetail !== null && itemDetail.header ? 'mb-3' : ''
                    "
                    v-html="itemDetail !== null && itemDetail.header"
                  ></div>

                  <div
                    class="mb-3"
                    v-html="itemDetail !== null && itemDetail.body"
                  ></div>
                </div>
              </td>
            </tr>
            <tr
              v-if="
                this.itemDetail !== null &&
                typeof this.itemDetail.display_flag !== 'undefined'
              "
            >
              <td class="td-left"></td>
              <td class="td-right">
                <div class="widget-checkbox">
                  <input
                    type="checkbox"
                    name="display"
                    v-model="displayCheckbox"
                  /><span class="ml-2">{{
                    $t('top-page.checkbox-show', {
                      split: '/'
                    })
                  }}</span>
                </div>
              </td>
            </tr>
          </table>

          <v-card-actions>
            <v-btn
              class="btn-logout mt-2"
              depressed
              color="#e8320e"
              @click="handleCloseDialog"
            >
              {{ $t('component.btn-close', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <hr class="hr-line-homepage" v-if="checkDisplayContactTo()" />

    <table class="table-homepage">
      <tbody>
        <tr>
          <td v-if="checkDisplayContactTo()">
            {{
              $t('top-page.text-field.contact-to', {
                split: '/'
              })
            }}
          </td>
          <td class="widget-button-info">
            <div
              class="mr-2"
              v-if="
                m_event !== null && m_event.contact_to_display === DISPLAY_TAG
              "
            >
              <v-btn icon color="#e8320e"> <v-icon>mdi-account</v-icon> </v-btn
              >{{ m_event.contact_to }}
            </div>

            <div
              class="mr-2"
              v-if="
                m_event !== null && m_event.contact_mail_display === DISPLAY_TAG
              "
            >
              <v-btn
                icon
                color="#e8320e"
                :href="`mailto:${m_event.contact_mail}`"
              >
                <v-icon>mdi-email</v-icon> </v-btn
              ><a :href="`mailto:${m_event.contact_mail}`">{{
                m_event.contact_mail
              }}</a>
            </div>

            <div
              class="mr-2"
              v-if="
                m_event !== null &&
                m_event.contact_phone_display === DISPLAY_TAG
              "
            >
              <v-btn
                icon
                color="#e8320e"
                :href="`tel:${m_event.contact_phone}`"
              >
                <v-icon>mdi-phone</v-icon> </v-btn
              ><a :href="`tel:${m_event.contact_phone}`">{{
                m_event.contact_phone
              }}</a>
            </div>

            <div
              class="mr-2"
              v-if="
                m_event !== null &&
                m_event.contact_address_display === DISPLAY_TAG
              "
            >
              <v-btn icon color="#e8320e"> <v-icon>mdi-map</v-icon> </v-btn
              >{{ m_event.contact_address }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <v-row
      v-if="m_event !== null && m_event.contact_button_display === DISPLAY_TAG"
    >
      <v-col class="text-center">
        <v-btn
          class="btn-update"
          depressed
          color="#E8320D"
          @click="handleShowDialogRequiry"
          >{{ $t('top-page.button-contact', { split: '/' }) }}</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="dialogRequiry" max-width="520">
      <v-card class="dialog-container">
        <v-icon
          color="#E8320D"
          class="close-icon"
          @click="handleCloseDialogRequiryIcon"
          >{{ closeIcon }}</v-icon
        >
        <div class="dialog">
          <table class="table-detail-info">
            <tr>
              <td class="td-left">
                {{
                  $t('top-page.title', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                <div class="input-relative">
                  <input
                    class="input-contact"
                    name=""
                    id=""
                    v-model="subject"
                  />

                  <div
                    class="error-input-dialog"
                    v-if="
                      $v.subject.$error &&
                      $v.subject.$dirty &&
                      !$v.subject.required
                    "
                  >
                    {{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td class="td-left">
                {{
                  $t('top-page.content', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                <div class="input-relative">
                  <textarea
                    class="input-contact"
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    v-model="body"
                  ></textarea>
                </div>
                <div
                  class="error-input-dialog"
                  v-if="$v.body.$dirty && $v.body.$error && !$v.body.required"
                >
                  {{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}
                </div>
              </td>
            </tr>
          </table>

          <v-card-actions class="d-flex justify-content-center">
            <v-btn
              class="btn-logout mt-2"
              depressed
              color="#e8320e"
              @click="handleCloseDialogRequiry"
            >
              {{ $t('component.btn-send-requiry', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiAccount, mdiClose } from '@mdi/js';
import {
  DISPLAY,
  UN_DISPLAY,
  DISPLAY_INFO,
  ITEM_PER_PAGE,
  TYPE_INFORMATION,
  TYPE_NOTIFICATION,
  READ_FLAG_UN_READ,
  READ_FLAG_READ,
  DISPLAY_TAG,
  UN_DISPLAY_TAG
} from '@/common/constants';
import './homepage.scss';
import '@/style/common.scss';
import ScrollTopBtn from '@/components/ScrollTopBtn';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'Homepage',
  components: { ScrollTopBtn },
  data() {
    return {
      userIcon: mdiAccount,
      closeIcon: mdiClose,
      headers: [
        { text: '', value: 'read_flag', align: 'center' },
        {
          text: this.$t('top-page.table-header.register-date', {
            split: '/'
          }),

          align: 'start',
          sortable: false,
          value: 'created_at'
        },
        {
          text: this.$t('top-page.table-header.topic', {
            split: '/'
          }),
          value: 'subject'
        },
        {
          text: this.$t('top-page.table-header.sender', {
            split: '/'
          }),
          value: 'sender'
        },
        {
          text: this.$t('top-page.table-header.expiration-date', {
            split: '/'
          }),
          value: 'display_time_to'
        }
      ],

      dialog: false,
      dialogRequiry: false,
      itemDetail: null,
      tableData: [],
      displayCheckbox: false,
      noDataText: this.$t('table-no-data', {
        split: '/'
      }),

      subject: '',
      body: ''
    };
  },

  validations: {
    subject: {
      required
    },

    body: {
      required
    }
  },

  methods: {
    openDialogRequiry() {
      this.dialogRequiry = true;
    },
    handleCloseDialogRequiryIcon() {
      this.dialogRequiry = false;
    },
    displayEventPeriod() {
      let stringDateTime = '';
      if (this.m_event !== null) {
        stringDateTime =
          this.convertDateAndTime(
            this.m_event.event_period_from_event_time_zone
          ) +
          ' ~ ' +
          this.convertDateAndTime(this.m_event.event_period_to_event_time_zone);
      }

      return stringDateTime;
    },
    timezoneFormat: function () {
      const arr = this.c_time_zone.filter(
        (ele) => ele.id === this.m_event.time_zone
      );

      if (arr.length > 0) {
        return '(' + arr[0].name_convert + ')';
      } else return null;
    },
    checkDisplayHr() {
      if (this.m_event !== null) {
        const {
          organizer_name_display,
          cooperator_display,
          sponsor_display,
          operator_display
        } = this.m_event;

        if (
          sponsor_display === this.UN_DISPLAY_TAG &&
          operator_display === this.UN_DISPLAY_TAG &&
          organizer_name_display === this.UN_DISPLAY_TAG &&
          cooperator_display === this.UN_DISPLAY_TAG
        ) {
          return false;
        }
      }
      return true;
    },

    checkDisplayContactTo() {
      if (this.m_event !== null) {
        const {
          contact_to_display,
          contact_mail_display,
          contact_phone_display,
          contact_address_display
        } = this.m_event;

        if (
          contact_to_display === this.UN_DISPLAY_TAG &&
          contact_mail_display === this.UN_DISPLAY_TAG &&
          contact_phone_display === this.UN_DISPLAY_TAG &&
          contact_address_display === this.UN_DISPLAY_TAG
        ) {
          return false;
        }
      }
      return true;
    },

    handleShowDetail(item) {
      this.itemDetail = Object.assign({}, item);
      this.dialog = true;

      if (item !== null && item.type_notification === TYPE_INFORMATION) {
        const info_log_applicant_id = item.id;

        this.displayCheckbox =
          item.display_flag == null || item.display_flag == DISPLAY_INFO
            ? false
            : true;
        this.$store.dispatch('updateReadFlagInfoLogApplicant', {
          info_log_applicant_id
        });
      }

      if (item !== null && item.type_notification === TYPE_NOTIFICATION) {
        const notification_applicant_id = item.id;

        this.displayCheckbox = item.display_flag == DISPLAY ? false : true;
        this.$store.dispatch('updateReadFlagNotificationApplicant', {
          notification_applicant_id
        });
      }
    },
    handleCloseDialog() {
      if (
        this.itemDetail !== null &&
        this.itemDetail.type_notification === TYPE_INFORMATION
      ) {
        if (this.displayCheckbox === true) {
          this.$store.dispatch('updateDisplayFlagInfoLogApplicant', {
            info_log_applicant_id: this.itemDetail.id
          });
        }
      }

      if (
        this.itemDetail !== null &&
        this.itemDetail.type_notification === TYPE_NOTIFICATION
      ) {
        if (this.displayCheckbox === true) {
          this.$store.dispatch('updateDisplayFlagNotificationApplicant', {
            notification_applicant_id: this.itemDetail.id
          });
        }
      }

      this.dialog = false;
    },

    handleCloseDialogRequiry() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.dialogRequiry = false;
        this.sendInquiry();
        this.subject = '';
        this.body = '';
      }
    },

    async sendInquiry() {
      if (!this.$v.$error) {
        const data = {
          subject: this.subject,
          body: this.body
        };
        await this.$store.dispatch('sendInquiry', data);
        this.$v.$reset();
      }
    },

    handleShowDialogRequiry() {
      this.dialogRequiry = true;
    }
  },

  created() {
    this.DISPLAY = DISPLAY;
    this.UN_DISPLAY = UN_DISPLAY;
    this.DISPLAY_TAG = DISPLAY_TAG;
    this.UN_DISPLAY_TAG = UN_DISPLAY_TAG;
    this.READ_FLAG_UN_READ = READ_FLAG_UN_READ;
    this.READ_FLAG_READ = READ_FLAG_READ;
    this.ITEM_PER_PAGE = ITEM_PER_PAGE;
    this.TYPE_NOTIFICATION = TYPE_NOTIFICATION;
    this.TYPE_INFORMATION = TYPE_INFORMATION;

    this.tableData =
      this.profile !== null ? this.profile.data_notification : [];
  },

  mounted() {
    if (this.$route.query) {
      const { noti } = this.$route.query;

      if (noti) {
        const itemArray = this.dataTable.filter((ele) => ele.id === noti);

        if (itemArray.length > 0) {
          this.handleShowDetail(itemArray[0]);
        }
      }
    }
  },

  watch: {
    '$route.query': function (val) {
      if (val) {
        const { noti } = val;

        if (noti) {
          const itemArray = this.dataTable.filter((ele) => ele.id === noti);

          if (itemArray.length > 0) {
            this.handleShowDetail(itemArray[0]);
          }
        }
      }
    },
    '$i18n.locale': function () {
      this.noDataText = this.$t('table-no-data', { split: '/' });
      return (this.headers = [
        { text: '', value: 'read_flag', align: 'center' },
        {
          text: this.$t('top-page.table-header.register-date', {
            split: '/'
          }),

          align: 'start',
          sortable: false,
          value: 'created_at'
        },
        {
          text: this.$t('top-page.table-header.topic', {
            split: '/'
          }),
          value: 'subject'
        },
        {
          text: this.$t('top-page.table-header.sender', {
            split: '/'
          }),
          value: 'sender'
        },
        {
          text: this.$t('top-page.table-header.expiration-date', {
            split: '/'
          }),
          value: 'display_time_to'
        }
      ]);
    },

    profile: function (val) {
      return val;
    }
  },

  computed: {
    ...mapGetters({
      m_event: 'getEventData',
      profile: 'getProfile',
      dataTable: 'getDataInformationAndNotification'
    })
  }
};
</script>
